import { ReactElement } from 'react'

import { Box } from '@chakra-ui/react'

export default function TabPanelContainer({ children }: any): ReactElement {
    return <Box minH={'70vh'}>{children}</Box>
}
